
  document.addEventListener("DOMContentLoaded", function () {
      function initHeroSwiper() {
        const swiperEl = document.querySelector(".hero-swiper");
        if (!swiperEl) return;

        new Swiper(swiperEl, {
          loop: false,
          autoplay: {
            delay: 5000,
            disableOnInteraction: true,
          },
          speed: 900,
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            nextEl: ".hero-next",
            prevEl: ".hero-prev",
          },
          effect: "slide", 
        });
      }

      initHeroSwiper();
      document.addEventListener("shopify:section:load", initHeroSwiper);
    });

document.addEventListener("DOMContentLoaded", function () {
  function initReviewSwiper() {
    new Swiper('.reviews-swiper', {
      
      loop: true,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1200: { slidesPerView: 3 }
      }
    });
  }

  initReviewSwiper();
  document.addEventListener("shopify:section:load", initReviewSwiper);
});



document.addEventListener("DOMContentLoaded", function() {
  const faqs = document.querySelectorAll(".faqs-main-section .faq-item");

  faqs.forEach((faq) => {
    const button = faq.querySelector(".faq-question");
    const answer = faq.querySelector(".faq-answer");

    button.addEventListener("click", () => {
      const isOpen = faq.classList.contains("active");

      // Close all others if needed
      faqs.forEach((item) => {
        item.classList.remove("active");
        const innerAnswer = item.querySelector(".faq-answer");
        innerAnswer.style.maxHeight = null;
      });

      // Toggle current smoothly
      if (!isOpen) {
        faq.classList.add("active");
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });
  });
})

document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('#subscribe_now');
  const messageBox = document.getElementById('subscribe-message');
  
  if (sessionStorage.getItem('formSubmitted')) {
    messageBox.innerHTML = `<p>Thank you for subscribing! We will keep you updated.</p>`;
    messageBox.style.color = 'green';
    sessionStorage.removeItem('formSubmitted');
  }

  form.addEventListener('submit', function(event) {
    event.preventDefault(); 

    const email = form.querySelector('input[name="contact[email]"]').value;

    if (email) {
      sessionStorage.setItem('formSubmitted', 'true');

      form.submit();
    } else {
      messageBox.innerHTML = `<p>Please enter a valid email address.</p>`;
      messageBox.style.color = 'red'; 
    }
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('#contact_form');
  const messageBox = document.getElementById('footer-form-message');
  
  if (sessionStorage.getItem('messageDisplayed') === 'true') {
    messageBox.style.display = 'none';
  }
  
  form.addEventListener('submit', function(event) {
    event.preventDefault(); 

    const emailInput = form.querySelector('input[name="contact[email]"]');
    const email = emailInput.value;

    if (validateEmail(email)) {
      messageBox.innerHTML = 'Your email has been submitted!';
      messageBox.classList.remove('error');
      messageBox.classList.add('success');

      sessionStorage.setItem('messageDisplayed', 'true');

      emailInput.value = '';
      
      
    } else {
      messageBox.innerHTML = 'Please enter a valid email address.';
      messageBox.classList.remove('success');
      messageBox.classList.add('error');
    }
  });

  function validateEmail(email) {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  }
});